module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/comments/comments.component.css
// module id = ./src/app/comments/comments.component.css
// module chunks = main